"use strict";
import { ADDING_START, ADDING_FINISH } from "../actions";
export default function addingComponentReducer(addingComponent = {}, action) {
  switch (action.type) {
    case ADDING_START: {
      const { coords, typeID, guid } = action;
      return {
        guid,
        typeID,
        start: coords
      };
    }
    case ADDING_FINISH: {
      return {};
    }
    default:
      return addingComponent;
  }
}
